import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import {
  SectionHeading,
  Subheading as SubheadingBase
} from "components/misc/Headings.js";
import IntroductionIcon from "images/custom/api-introduce.svg";
import BackgroundImage from "images/custom/memphis-colorful.png";
import { HASH_API } from "helpers/Constants";

const Container = styled.div`
  ${tw`relative -mx-8 px-8 py-16`}
  ${css`
    background-image: url(${BackgroundImage});
    background-repeat: repeat;
  `}
`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-5/12 flex-shrink-0 h-80 md:h-auto relative`;
const TextColumn = styled(Column)(props => [
  tw`md:w-5/12 mt-16 md:mt-0`,
  props.textOnLeft
    ? tw`md:mr-12 lg:mr-16 md:order-first`
    : tw`md:ml-12 lg:ml-16 md:order-last`
]);

const Image = styled.div(props => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded bg-contain bg-no-repeat bg-center h-full`
]);
const TextContent = tw.div`lg:py-8 text-center md:text-left`;

const Subheading = tw(
  SubheadingBase
)`text-center text-lg lg:text-2xl tracking-tight text-skywatch-primary900 md:text-left`;
const Heading = tw(
  SectionHeading
)`mt-4 font-bold text-left text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Description = tw.p`mt-4 text-center md:text-left text-base lg:text-lg font-medium leading-relaxed text-skywatch-textGray`;

const Statistics = tw.div`flex flex-col items-center sm:block text-center md:text-left mt-4`;
const Statistic = tw.div`text-left sm:inline-block sm:mr-12 last:mr-0 mt-4`;
const Value = tw.div`font-bold text-4xl text-secondary-500 tracking-wide`;
const Key = tw.div`font-medium text-lg text-skywatch-primary900`;

export default ({
  subheading = "API 系統串接快速整合各種應用",
  heading = "雲端監控 API 串接",
  description = "Skywatch 能與不同的系統整合，讓你的管理系統擁有即時錄影、智慧縮時、智慧日誌等雲端監控服務，透過輕鬆便捷的 API 串接，將我們的功能變成你的服務。",
  imageSrc = IntroductionIcon,
  imageCss = null,
  imageContainerCss = null,
  imageInsideDiv = true,
  statistics = null,
  textOnLeft = false
}) => {
  // The textOnLeft boolean prop can be used to display either the text on left or right side of the image.
  //Change the statistics variable as you like, add or delete objects
  const defaultStatistics = [
    {
      key: "影像 AI 運算次數",
      value: "100M+"
    },
    {
      key: "管理物聯網裝置",
      value: "200K+"
    },
    {
      key: "攝影機連線數",
      value: "100K+"
    }
  ];

  if (!statistics) statistics = defaultStatistics;

  return (
    <Container id={HASH_API}>
      <TwoColumn css={!imageInsideDiv && tw`md:items-center`}>
        <ImageColumn css={imageContainerCss}>
          {imageInsideDiv ? (
            <Image imageSrc={imageSrc} css={imageCss} />
          ) : (
            <img src={imageSrc} css={imageCss} alt="" />
          )}
        </ImageColumn>
        <TextColumn textOnLeft={textOnLeft}>
          <TextContent>
            {subheading && <Subheading>{subheading}</Subheading>}
            <Heading>{heading}</Heading>
            <Description>{description}</Description>
            <Statistics>
              {statistics.map((statistic, index) => (
                <Statistic key={index}>
                  <Value>{statistic.value}</Value>
                  <Key>{statistic.key}</Key>
                </Statistic>
              ))}
            </Statistics>
          </TextContent>
        </TextColumn>
      </TwoColumn>
    </Container>
  );
};
